import {
  CRYPTO_PAYMENT,
  CRYPTO_PAYMENT_SUCCESS,
  CRYPTO_PAYMENT_FAILURE,
} from "../actionTypes";

export const cryptoPayment = (payload) => ({
  type: CRYPTO_PAYMENT,
  payload,
});

export const cryptoPaymentSuccess = (payload) => ({
  type: CRYPTO_PAYMENT_SUCCESS,
  payload,
});

export const cryptoPaymentFailure = () => ({
  type: CRYPTO_PAYMENT_FAILURE,
});
